import React, { useState, useEffect, useRef } from "react";
import {
  getDataFromApi,
  postDataFromApi,
} from "../../../services/commonServices";
import { Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import {
  decryptDataForURL
} from "../../../utills/useCryptoUtils";
import { truncateText } from "../../../services/commonFunction";

const DropDownWithLoadMore = ({ field }) => {
  let {
    name,
    label,
    value,
    onChange,
    required,
    options,
    fieldWidth,
    masterOptions,
    customname,
    from,
    placeholder,
    actionClicked,
    isSearchable,
    readOnly,
    model_name,
    apiendpoint,
    apimethod,
    optionData,
    labelWidth,
    isCustomPayload,
    formData,
    setFormData,
    customPayload,
    queryString,
    moduleType,
    isEditMode,
    upperClass,
    allProps,
    defaultValue
  } = field;
  const isMulti = allProps.isMultiSelect
  const [items, setItems] = useState([]);
  const [nextPage, setNextPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  // const [defaultValue, setDefaultValue] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const [totalPage, setTotalPage] = useState(10);

  const [isCalled, setISCalled] = useState(false);
  const [defaultOptions, setDefaultOption] = useState(null);
  const dropdownMenuRef = useRef(null);
  const isClearingSelection = useRef(false);
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setNextPage(1);
  };

  useEffect(() => {
    if (allProps.defaultValue && !isMulti) {
      setTimeout(() => {
        setSelectedItems(allProps.defaultValue);
        setExistingOpt(allProps.defaultValue);
        onChange(allProps.defaultValue, 1);
      }, 10)
    }
  }, [allProps.defaultValue]);


  useEffect(() => {
    if (isCustomPayload) {
      if (formData[0]?.[customPayload?.value] || customPayload.defaultValue) {
        // if (!(isEditMode)) {
        // if (!(isEditMode && ['operationCertificate', 'jobinstruction', 'vesselJICertificate', 'consortiumorder'].includes(moduleType))) {
        fetchData(searchQuery.length > 2 || searchQuery.length === 0, searchQuery.length === 0);
        // }
      }
    }
    else {
      if (searchQuery) {
        if (searchQuery.length > 2) {
          fetchData(true);
        }
      }
      else {
        // if (!(isEditMode && ['operationCertificate', 'jobinstruction', 'vesselJICertificate', 'consortiumorder'].includes(moduleType))) {
        // if (!(isEditMode)) {
        fetchData(true, 1);


        // }
      }
    }
  }, [formData[0]?.[customPayload?.value], searchQuery, apiendpoint])
  const fetchData = async (reset = false, forDefaulrshow = "") => {
    if (readOnly && forDefaulrshow && !value) {
      return
    }
    try {
      let tempBody = {
        model_name: model_name,
        load_more: true,
        is_dropdown: true,
        is_search_dropdowm: true,
      };
      if (forDefaulrshow) {
        tempBody.pre_selected_id = value;
      }
      if (isMulti) {
        if (existingOpt.length) {
          tempBody.pre_selected_id = existingOpt;
        }
      }
      if (name == "fk_invoice_branchid") {
        tempBody.is_invoice_state = true;
      }

      let res;

      let newEndPoint = apiendpoint || "";
      const baseHasQuery = newEndPoint.includes("?");
      const joiner = baseHasQuery ? "&" : "?";
      const qsPrefix = queryString ? `${queryString}&` : "";
      if (nextPage > 0) {
        newEndPoint = `${newEndPoint}${joiner}${qsPrefix}page=${nextPage}&search=${encodeURIComponent(
          searchQuery
        )}`;
      } else {
        newEndPoint = `${newEndPoint}${joiner}${qsPrefix}search=${encodeURIComponent(
          searchQuery
        )}`;
      }
      if (allProps?.isIncludes) {
        if (apimethod === "GET") {
          newEndPoint = newEndPoint + "&default_data=" + allProps?.includesData
        }
        else {
          tempBody.default_data = allProps?.includesData;
        }
      }

      let customBody = {
        // cmd_id: 1,
        is_dropdown: true,
        search_text: searchQuery,
        model_name: model_name,
      }
      if (isCustomPayload) {
        if (apimethod === "GET") {
          newEndPoint = newEndPoint + `&${customPayload?.name}=${formData[0]?.[customPayload?.value] || customPayload.defaultValue}`
        } else {
          customBody[customPayload?.name] = formData[0]?.[customPayload?.value] || customPayload.defaultValue
        }

      }
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const Type = decryptDataForURL(params.get("type"));



      if (apimethod === "GET") {
        newEndPoint =
          newEndPoint + "&is_dropdown=" + true + "&load_more=" + true;
        if (forDefaulrshow) {
          if (value != "NA") {
            if (isMulti) {
              if (existingOpt.length) {
                newEndPoint = newEndPoint + "&pre_selected_id=" + existingOpt;
              }
              else {
                newEndPoint = newEndPoint + "&pre_selected_id=" + value;
              }
            }
            else {
              newEndPoint = newEndPoint + "&pre_selected_id=" + value;
            }
          }
        }
        if (isMulti) {
          if (existingOpt.length) {
            newEndPoint = newEndPoint + "&pre_selected_id=" + existingOpt;
          }
        }
        res = await getDataFromApi(newEndPoint, tempBody, "");
      } else if (apimethod === "POST") {
        if (isCustomPayload) {
          res = await postDataFromApi(newEndPoint, customBody);
        }
        else {
          res = await postDataFromApi(newEndPoint, tempBody);
        }
      }

      if (res.data.status === 200) {
        setISCalled(true);
        setTotalPage(res.data.total_pages || 10);
        // if (name == "fk_invoice_branchid") {
        //   setFormData((prevFormData) => {
        //     return {
        //       ...prevFormData,
        //       [0]: {
        //         ...prevFormData[0],
        //         "fk_im_state": res.data.data?.[0]?.fk_br_state__state_name,
        //         // "im_billtoplace": res.data.data?.[0]?.fk_br_state__state_name,
        //         // "im_shiptoplace": res.data.data?.[0]?.fk_br_state__state_name,
        //       },
        //     };
        //   });
        // }
        if (forDefaulrshow) {
          const preSeleOpt = res?.data?.data?.find((singleVal, i) => singleVal[optionData.id] == value)
          setDefaultOption(preSeleOpt)
        }
        if (reset) {
          setItems(res?.data?.data);
        } else {
          setItems((prevItems) => [...prevItems, ...res.data.data]);
        }
        setHasMore(res?.data?.links?.next !== null);
        if (!reset) {
          // setNextPage((prevPage) => prevPage + 1);
        }
        else {
          setNextPage(1);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const [newOptions, setNewOptions] = useState([]);
  const [selectedItems, setSelectedItems] = useState(isMulti ? [] : null);
  const [existingOpt, setExistingOpt] = useState(isMulti ? [] : null);
  const [selectedItemName, setSelectedItemName] = useState(isMulti ? [] : null);
  const [isToggleOpen, setIsToggleOpen] = useState(false);
  const toggleOption = (e, value, option) => {
    if (isMulti) {
      setSelectedItems((prev) => {
        let updated = []
        let selectedNames = []
        if (prev.includes(value)) {
          updated = prev.filter((v) => v !== value);
          selectedNames = selectedItemName.filter((v) => v?.[optionData.id] !== option?.[optionData.id]);
        } else {
          updated = [...prev, value];
          selectedNames = [...selectedItemName, option];
          // onChange(updated, 1, option);
        }

        setSelectedItemName(selectedNames)
        return updated;
      });
      setExistingOpt((prev) => {
        let updated = []
        if (prev.includes(value)) {
          updated = prev.filter((v) => v !== value);
        } else {
          updated = [...prev, value];
        }
        return updated;
      });
    } else {
      setSelectedItems(value);
      setExistingOpt(value);
      setSelectedItemName(option)
      onChange(value, 1, option);
    }
  };
  const clearSelection = () => {
    const clearedValue = isMulti ? [] : "";
    isClearingSelection.current = isMulti;
    setSelectedItems(clearedValue);
    setExistingOpt(clearedValue);
    setSelectedItemName(clearedValue);
    onChange(clearedValue, 1, isMulti ? [] : null);
  };
  useEffect(() => {
    masterOptions?.map((model, index) => {
      if (model.model === name || model.model === customname) {
        setNewOptions(model.data);
      }
    });
  }, [options, newOptions, name, masterOptions]);

  const [errorMsg, setErrorMsg] = useState("");
  useEffect(() => {
    if ((value === undefined || value === "") && required) {
      setErrorMsg(label + " is required");
    } else {
      checkDefaultSelected();
      setErrorMsg("");
    }
    if (value && !actualOptData()?.find((item, index) => item[optionData.id] === value)) {
      fetchData(true, 1);
    }
    setExistingOpt(value)
  }, [value]);
  useEffect(() => {
    checkDefaultSelected();
  }, [items]);
  const checkDefaultSelected = () => {
    if (!isMulti) {
      const filterData = actualOptData()?.filter((item) => {
        return item[optionData.id] === value;
      });
      if (filterData.length > 0) {
        setSelectedItems(filterData[0][optionData.id]);
        setSelectedItemName(filterData[0])
        if (name == "fk_invoice_branchid") {
          setFormData((prevFormData) => {
            return {
              ...prevFormData,
              [0]: {
                ...prevFormData[0],
                "fk_im_state": filterData[0]?.fk_br_state__state_name,
                // "im_billtoplace": filterData[0]?.fk_br_state__state_name,
                // "im_shiptoplace": filterData[0]?.fk_br_state__state_name,
              },
            };
          });
        }
      }
      else {
        setSelectedItems(null);
        setSelectedItemName(null);
      }
    }
    else {
      const filterData = actualOptData()?.filter((item) => {
        return value.includes(item[optionData.id])
      });
      setSelectedItems(value || [])
      setSelectedItemName(filterData || [])
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (isOpen) {
      const element = dropdownMenuRef.current;
      if (element) {
        element.addEventListener('scroll', handleScroll);
        return () => {
          element.removeEventListener('scroll', handleScroll);
        }
      }
    }
  }, [isOpen]);

  // Your handleScroll function
  useEffect(() => {
    if (nextPage > 1 && nextPage <= totalPage) {
      if (isCustomPayload) {
        if (formData[0]?.[customPayload?.value] || customPayload.defaultValue) {
          fetchData();
        }
      }
      else {
        fetchData();
      }

    }
  }, [nextPage, totalPage]);

  const handleScroll = () => {
    const element = dropdownMenuRef.current;
    if (element) {
      if (element?.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
        setNextPage((prevPage) => prevPage + 1); // Increment page here
      }
    }
  };
  const searchInputRef = useRef(null);
  const actualOptData = () => {
    if (defaultOptions) {
      if (!items.find((singleVal, i) => singleVal[optionData.id] == value)) {
        return [defaultOptions, ...items]
      }
    }
    return items
  }
  const getSelectedLabel = () => {
    if (isMulti) {
      // return selectedItems
      //   .map((id) => actualOptData().find((item) => item[optionData.id] === id)?.[optionData.label])
      //   .join(", ");
      return selectedItems?.length > 0 ? selectedItemName.map((data) => data[optionData.label] + ((optionData?.label3 && data[optionData?.label3]) ?
        ` ${data[optionData?.label3]} ` : '') + ((optionData?.label2 && data[optionData?.label2]) ? `(${data[optionData?.label2]})` : '')).join(',') : placeholder || `Select ${label}`
    } else {
      return selectedItemName ? selectedItemName?.[optionData.label] + ((optionData?.label3 && selectedItemName?.[optionData?.label3]) ? ` ${selectedItemName?.[optionData?.label3]} ` : '') + ((optionData?.label2 && selectedItemName?.[optionData?.label2]) ? `(${selectedItemName?.[optionData?.label2]})` : '') : placeholder || `Select ${label}`
      // const sel = actualOptData().find((item) => item[optionData.id] === selectedItems);
      // return sel ? sel[optionData.label] : placeholder || `Select ${label}`;
    }
  };
  return (
    <div className={`${allProps?.isFromDoubleText ? 'doubletextfield ' : 'form-group my-2'} ${upperClass || ''}`} id={name || label} style={{ position: "relative" }}>
      {from !== "Table" && label && (
        <label htmlFor={name} style={{ width: labelWidth || `${25}%` }}>
          {label}
          <span className="required_mark"> {required ? ` *` : null}</span>
        </label>
      )}
      <div className={"w-" + (fieldWidth ?? "75") + " d-inline-block "+(allProps?.isFromDoubleText ? '' : 'mx-2' )} title={getSelectedLabel()}>
        <Dropdown className={"w-100" + " d-inline-block  specialInnerSelect " + (readOnly && "labelInput")  }
          onToggle={(isOpen) => {
            setIsOpen(isOpen)
            if (isOpen) {
              setTimeout(() => {
                if (searchInputRef.current) {
                  searchInputRef.current.focus();
                }
              }, 300);
            }
            else {
              if (isMulti && selectedItems?.length > 0 && !isClearingSelection.current) {
                const selectedItemsOPt = actualOptData().filter((item) => existingOpt?.includes(item[optionData.id]))
                onChange(existingOpt, 1, selectedItemsOPt)
              }
              isClearingSelection.current = false;

            }
          }}
          autoClose={isMulti ? "outside" : true}>
          <Dropdown.Toggle id="dropdown-basic" disabled={readOnly}  >
            {" "}
            <span className="multipleSelectHeader">
              {truncateText(getSelectedLabel(), 45)}
              {/* {getSelectedLabel()} */}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="loadmore_dropdown_menu"  >
            {isSearchable && (
              <>
                <input
                  type="text"
                  ref={searchInputRef}
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearch}
                  className="loadMoreInput"
                />
                <br />
              </>
            )}
            {(isMulti ? selectedItems?.length > 0 : selectedItems !== null && selectedItems !== undefined && selectedItems !== "") && (
              <Dropdown.Item
                className="loadMoreClearSelection"
                onClick={clearSelection}
              >
                <span className="loadMoreClearIcon" aria-hidden="true">×</span>
                <span>Clear selection</span>
              </Dropdown.Item>
            )}

            <div className="loadMoreOptions" ref={dropdownMenuRef}>

              {actualOptData()?.map((item, index) => {
                const label1 = item?.[optionData?.label] || "";
                const label2 = item?.[optionData?.label2] || "";
                const label3 = item?.[optionData?.label3] || "";

                const combined = `${label1} ${label3} ${label2}`.toLowerCase();
                if (!combined.includes(searchQuery.toLowerCase())) {
                  return null
                }
                return (
                  <Dropdown.Item
                    value={item[optionData.id]}
                    key={"Dropdown-" + index}
                    onClick={(e) => toggleOption(e, item[optionData.id], item)}
                    active={isMulti ? selectedItems?.includes(item[optionData.id]) : selectedItems === item[optionData.id]}
                    title={item[optionData.label] + (item?.[optionData?.label3] ? ` ${item[optionData?.label3]} ` : '') + (optionData?.label2 && item?.[optionData?.label2] ? ` (${item[optionData?.label2]})` : "")}
                  >
                    {item[optionData.label]}{" "} {item?.[optionData?.label3] ? `${item[optionData?.label3]} ` : ''}

                    {optionData?.label2 && (item?.[optionData?.label2]) ? `(${item[optionData?.label2]})` : ""}

                  </Dropdown.Item>
                )
              })}
            </div>
          </Dropdown.Menu>
        </Dropdown>
        {errorMsg && actionClicked && (
          <p className="text-danger errorMsg">{errorMsg}</p>
        )}
      </div>
    </div >
  );
};

DropDownWithLoadMore.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
    ]),
    onChange: PropTypes.func,
    required: PropTypes.bool,
    options: PropTypes.array,
    error: PropTypes.string,
    fieldWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    multiple: PropTypes.bool,
    placeholder: PropTypes.string,
    masterOptions: PropTypes.array,
    customname: PropTypes.string,
    actionClicked: PropTypes.func,
    specialClass: PropTypes.string,
    from: PropTypes.string,
    viewOnly: PropTypes.bool,
    staticOptions: PropTypes.bool,
    isMulti: PropTypes.bool, // NEW: multi-select prop
  }),
};

export default DropDownWithLoadMore;
